import React from 'react';
import { Tooltip } from 'antd';

import './styles.scss';

const CustomLabel = (props) => {
  const {
    title,
    required,
    customClass,
    optionalText,
    icon,
    tooltipText,
  } = props;

  return (
    <label className={`add-form-label ${customClass}`}>
      {title}
      {optionalText && <span className="optional-text">{optionalText}</span>}
      {required && <span className="label-asteric">*</span>}
      {icon && (
        <Tooltip title={tooltipText ? tooltipText : ''}>
          <figure className="absolute-icon">{icon}</figure>
        </Tooltip>
      )}
    </label>
  );
};
export default CustomLabel;
